import { render, staticRenderFns } from "./TicketMyView.vue?vue&type=template&id=51c254f0&scoped=true"
import script from "./TicketMyView.vue?vue&type=script&lang=js"
export * from "./TicketMyView.vue?vue&type=script&lang=js"
import style0 from "./TicketMyView.vue?vue&type=style&index=0&id=51c254f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c254f0",
  null
  
)

export default component.exports